<template>
    <div class="page">
        <toolbar-system></toolbar-system>
        <progress-system :isLoad="system.progress"></progress-system>
        <alertbar-system v-if="system.AlertbarShow != null" :alertbar="system.AlertbarShow"></alertbar-system>
        <v-container>
            <v-layout>
                <v-flex xl12>
                    <v-card flat>
                        <v-card-title>
                            <v-autocomplete
                                v-model="IdTurma"
                                :rules="[v => !!v || 'Campo obrigatório']"
                                :items="turmas"
                                item-text="Curso"
                                item-value="IdCurso"
                                label="Selecione a turma"
                                @change="getNotificationsTurma()"
                            >
                                <template #item="{ item }">
                                    {{ item.Descricao }} - {{ item.GradeDescricao }}
                                </template>
                            </v-autocomplete>
                        </v-card-title>
                        <v-data-table
                            :headers="headersTurma"
                            :items="notifications"
                            :search="search"
                            :loading="loadingTable"
                            :pagination.sync="pagination"
                            item-key="IdPessoaFisica"
                        >
                            <template v-slot:items="props">
                                <tr>
                                    <td class="text-xs-center">
                                        <v-icon @click="toggleExpand(props.item)">
                                            {{ props.expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                                        </v-icon>
                                    </td>

                                    <td class="">{{ props.item.Nome }}</td>

                                    <td class="align-center justify-center">
                                        <v-chip
                                            color="green"
                                            v-if="props.item.Efetivada == 1"
                                            dark
                                        >
                                            Efetivado
                                        </v-chip>
                                        <v-chip
                                            color="orange"
                                            v-else
                                            dark
                                            class="d-flex align-center justify-center"
                                        >
                                            Não efetivado
                                        </v-chip>
                                    </td>

                                    <td class="text-xs-center">
                                        <v-badge
                                            v-if="props.item.notifications.length"
                                            :content="props.item.notifications.length"
                                            color="red"
                                            overlap
                                        >
                                            <v-icon color="blue">
                                                mdi-bell-ring
                                            </v-icon>
                                            {{ props.item.notifications.length }}
                                        </v-badge>

                                        <v-icon
                                            v-else
                                            color="red"
                                        >
                                            mdi-bell-off-outline
                                        </v-icon>
                                    </td>

                                    <!-- <td class="text-xs-center">
    
                                        <v-icon 
                                        color="green"
                                        label="push"
                                        class="align:center"
                                        v-if="props.item.notification_efetivado_push == 1"
                                        >
                                            mdi-cellphone
                                        </v-icon>
                                        <v-icon color="red" v-else>
                                            mdi-cellphone
                                        </v-icon>

                                        <v-icon 
                                        color="green"
                                        label="E-mail"
                                        v-if="props.item.notification_efetivado_mail == 1"
                                        >
                                            mdi-email-outline
                                        </v-icon>
                                        <v-icon color="red" v-else>
                                            mdi-email-outline
                                        </v-icon>
                                    </td>

                                    <td class="text-xs-center">
                                        <v-icon color="green"
                                        v-if="props.item.notification_reserva_push == 1"
                                        >
                                            mdi-cellphone
                                        </v-icon>
                                        <v-icon color="red" v-else>
                                            mdi-cellphone
                                        </v-icon>

                                        <v-icon color="green"
                                        v-if="props.item.notification_reserva_mail == 1"
                                        >
                                            mdi-email-outline
                                        </v-icon>
                                        <v-icon color="red" v-else>
                                            mdi-email-outline
                                        </v-icon>
                                    </td>

                                    <td class="text-xs-center">
                                        <v-icon color="green"
                                        v-if="props.item.notification_inicio_push == 1"
                                        >
                                            mdi-cellphone
                                        </v-icon>
                                        <v-icon color="red" v-else>
                                            mdi-cellphone
                                        </v-icon>

                                        <v-icon color="green"
                                        v-if="props.item.notification_inicio_mail == 1"
                                        >
                                            mdi-email-outline
                                        </v-icon>
                                        <v-icon color="red" v-else>
                                            mdi-email-outline
                                        </v-icon>
                                    </td>

                                    <td class="text-xs-center">
                                        <v-icon color="green"
                                        v-if="props.item.notification_termino_push == 1"
                                        >
                                            mdi-cellphone
                                        </v-icon>
                                        <v-icon color="red" v-else>
                                            mdi-cellphone
                                        </v-icon>

                                        <v-icon color="green"
                                        v-if="props.item.notification_termino_mail == 1"
                                        >
                                            mdi-email-outline
                                        </v-icon>
                                        <v-icon color="red" v-else>
                                            mdi-email-outline
                                        </v-icon>
                                    </td>
                                </tr> -->

                                <tr v-if="isExpanded(props.item)">
                                    <td :colspan="headersTurma.length">
                                        <v-card flat class="pa-3">
                                            <strong>Notificações</strong>

                                            <v-divider class="my-2"></v-divider>

                                            <v-list dense>
                                                <template v-if="props.item.notifications && props.item.notifications.length">
                                                    <v-list-item
                                                        v-for="(n, index) in props.item.notifications"
                                                        :key="index"
                                                    >
                                                        <v-list-item-content>
                                                            <v-icon left small>
                                                                {{ n.notification_type === 'push' ? 'mdi-cellphone' : 'mdi-email-outline' }}
                                                            </v-icon>

                                                            <v-list-item-title>
                                                                {{ n.notification_title }}
                                                            </v-list-item-title>

                                                            <v-list-item-subtitle>
                                                                {{ n.notification_text }}
                                                            </v-list-item-subtitle>

                                                            <div class="mt-1">
                                                                <span class="ml-2 grey--text">
                                                                    Enviado em {{ format_date(n.created_at) }}
                                                                    {{ n.usuario_id ? ('por ' + n.usuario) : ' de forma automática' }}
                                                                </span>
                                                            </div>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </template>

                                                <v-alert v-else type="info" dense>
                                                    Nenhuma notificação encontrada
                                                </v-alert>
                                            </v-list>
                                        </v-card>
                                    </td>
                                </tr>
                            </template>                            
                        </v-data-table>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
import ToolbarSystem from '../../../components/ToolbarSystem'
import AlertbarSystem from '../../../components/AlertbarSystem'
import ProgressSystem from '../../../components/ProgressSystem'
import moment from 'moment'
export default {
    components:{
        ToolbarSystem,
        AlertbarSystem,
        ProgressSystem
    },
    data () {
        return{
            system:{
                sideIcon: true,
                progress: true,
                AlertbarShow: null
            },
            headersTurma:[
                {text: '', value: 'data-table-expand' },
                {text:'Nome do aluno', value:'Nome', width:"60%", align:"left"},
                {text:'Situação', value:'Efetivado', width:"20%", align:"left"},
                {text:'Quantidade recebida', value:'notification_efetivado_push', width:"20%", align:"left"},
                // {text:'Efetivado', value:'notification_efetivado_push', width:"10%", align:"center"},
                // {text:'Reserva', value:'notification_reserva_push', width:"10%", align:"center"},
                // {text:'Inicio', value:'notification_start_push', width:"10%", align:"center"},
                // {text:'Final', value:'notification_end_push', width:"10%", align:"center"}
            ],
            rules: {
                required: v => !!v || 'Campo obrigatório',
            },
            turmas: [],
            expandedRows: [],
            IdTurma: 1,
            notifications: [],
            search: null,
            todayDate: null,
            loadingTable: false,

            pagination: {
                rowsPerPage: 3000
            },
        }
    },
    methods: {
        get_date_today(){
            const today = new Date();
            const year = today.getFullYear();
            const month = today.getMonth() + 1;
            const day = today.getDate();
            
            const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
            this.todayDate = formattedDate;
        },
        format_date(value){
            if (value) {
                return moment(String(value)).format('DD/MM/YYYY HH:mm');
            }
        },
        getTurmas() {
            this.turmas = []
            this.$axios.get(`curso`).then((res) => {
                this.turmas = res.data;                
            })
            .finally(() => {
                this.system.progress = false;
            })
        },
        getNotificationsTurma(){
            this.loadingTable = true            
            this.axios.get(`getNotificationsTurma/${this.IdTurma}`).then(res => {
                this.notifications = res.data
            }).finally(() => {
                this.system.progress = false;
                this.loadingTable = false
            })
        },        
        toggleExpand(item) {
            const index = this.expandedRows.indexOf(item.IdPessoaFisica)

            if (index > -1) {
                this.expandedRows.splice(index, 1)
            } else {
                this.expandedRows.push(item.IdPessoaFisica)
            }
        },
        isExpanded(item) {
            return this.expandedRows.includes(item.IdPessoaFisica)
        }    
    },
    mounted(){
        this.getTurmas();
        this.get_date_today();
    }
}
</script>
<style>
</style>

